import {
  IMediaTypeGroup,
  ICreateMediaTypeGroupAction,
  IGetMediaTypeGroupByIdAction,
  IGetMediaTypeGroupByIdSuccessAction,
  IFailureAction,
  IUpdateMediaTypeGroupAction,
  IUpdateMediaTypeGroupSuccessAction,
  IDeleteMediaTypeGroupAction,
  IDeleteMediaTypeGroupSuccessAction,
  ICreateMediaTypeGroupSuccessAction,
} from '../types/mediaTypeGroup'
import { types } from '../types/mediaTypeGroup'

export const createMediaTypeGroup = (
  mediaTypeGroupData: IMediaTypeGroup
): ICreateMediaTypeGroupAction => ({
  type: types.CREATE_MEDIA_TYPE_GROUP__STARTED,
  mediaTypeGroupData,
})

export const createMediaTypeGroupSuccess = (
  mediaTypeGroupData: IMediaTypeGroup,
  message: string
): ICreateMediaTypeGroupSuccessAction => ({
  type: types.CREATE_MEDIA_TYPE_GROUP__SUCCESS,
  mediaTypeGroupData,
  message,
})

export const createMediaTypeGroupFailure = (
  message: string
): IFailureAction => ({
  type: types.CREATE_MEDIA_TYPE_GROUP__FAILURE,
  message,
})

export const getMediaTypeGroupById = (
  id: string
): IGetMediaTypeGroupByIdAction => ({
  type: types.GET_MEDIA_TYPE_GROUP_BY_ID__STARTED,
  id,
})

export const getMediaTypeGroupByIdSuccess = (
  mediaTypeGroupData: IMediaTypeGroup
): IGetMediaTypeGroupByIdSuccessAction => ({
  type: types.GET_MEDIA_TYPE_GROUP_BY_ID__SUCCESS,
  mediaTypeGroupData,
})

export const getMediaTypeGroupByIdFailure = (
  message: string
): IFailureAction => ({
  type: types.GET_MEDIA_TYPE_GROUP_BY_ID__FAILURE,
  message,
})

export const updateMediaTypeGroup = (
  mediaTypeGroupData: IMediaTypeGroup
): IUpdateMediaTypeGroupAction => ({
  type: types.UPDATE_MEDIA_TYPE_GROUP__STARTED,
  mediaTypeGroupData,
})

export const updateMediaTypeGroupSuccess = (
  mediaTypeGroupData: IMediaTypeGroup,
  message: string
): IUpdateMediaTypeGroupSuccessAction => ({
  type: types.UPDATE_MEDIA_TYPE_GROUP__SUCCESS,
  mediaTypeGroupData,
  message,
})

export const updateMediaTypeGroupFailure = (
  message: string
): IFailureAction => ({
  type: types.UPDATE_MEDIA_TYPE_GROUP__FAILURE,
  message,
})

export const deleteMediaTypeGroup = (
  id: string
): IDeleteMediaTypeGroupAction => ({
  type: types.DELETE_MEDIA_TYPE_GROUP__STARTED,
  id,
})

export const deleteMediaTypeGroupSuccess = (
  message: string
): IDeleteMediaTypeGroupSuccessAction => ({
  type: types.DELETE_MEDIA_TYPE_GROUP__SUCCESS,
  message,
})

export const deleteMediaTypeGroupFailure = (
  message: string
): IFailureAction => ({
  type: types.DELETE_MEDIA_TYPE_GROUP__FAILURE,
  message,
})
